export default "__VITE_ASSET__B7xF9RYX__"